import React from 'react'

export const ContainerHeadingForgotPass = () => {
  return (
    <section className="heading">           
        <h1 className='tittleForgotPass'>Recuperar Contraseña</h1>
        <p className='textForgotPass'>Introduce tu correo electrónico para hacer el envió del enlace de recuperación</p>
    </section>
  )
}
